import React from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';

import messages from '../messages';
import style from '../style.module.less';

const SelectedPickupContact = () => {
  usePickupSettingsContextTypes('SelectedPickupContact');
  const { selectedContact } = usePickupSettingsContext();
  return (
    <>
      <p className={classnames(style.title, style.contact)}>
        <FormattedMessage {...messages.pickupContact} />
      </p>
      <div>
        {selectedContact?.firstName} {selectedContact?.lastName}
      </div>
      <div>
        {selectedContact?.phoneNumber} {selectedContact?.phoneNumberExtension}
      </div>
      <div>{selectedContact?.emailAddress}</div>
      {!selectedContact && <div>--</div>}
    </>
  );
};

export default SelectedPickupContact;
